import { Link } from 'react-router-dom';
import AnimationCard from './AnimationCard';
import type { Animation } from '../types';

interface AnimationCarouselProps {
  title: string;
  items: Animation[];
  /** 見出し行右端の「もっと見る」リンク先。 */
  moreHref: string;
  /** カードサイズ。lg=注目セクション用（大きめ）、md=既定。 */
  size?: 'lg' | 'md';
}

/**
 * トップページのセクション行（見出し + 横スクロールカルーセル1行）。
 * items が0件のときは呼び出し側で条件分岐せずに済むよう、ここで何も描画しない。
 */
export default function AnimationCarousel({
  title,
  items,
  moreHref,
  size = 'md',
}: AnimationCarouselProps) {
  if (items.length === 0) return null;

  return (
    <section className="carousel-section">
      <div className="carousel-section__head">
        <h2>{title}</h2>
        <Link to={moreHref} className="more">
          もっと見る
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M9 6l6 6-6 6"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
      <div className={`carousel carousel--${size}`}>
        <div className="carousel__track">
          {items.map((a) => (
            <div className="carousel__item" key={a.id}>
              <AnimationCard animation={a} />
            </div>
          ))}
        </div>
        <div className="carousel__fade" aria-hidden="true" />
      </div>
    </section>
  );
}
